import InquiryCard from '@jdh-cargo/block-content-inquiry-card';
import { useEffect } from 'react';
import BreadCrumb from '../BreadCrumb';
import { setHospitalTDK } from 'utils/hospital';
import { Template } from '../template';

export default () => {
  setHospitalTDK('京东健康问诊记录 - 京东健康互联网医院', '京东健康问诊记录', '京东健康问诊记录');
  return (
    <Template>
      <BreadCrumb title="患友问诊"></BreadCrumb>
      <InquiryCard moreUrl="inquiryList" paging={true} hideWhenAnswerListNone={true}/>
    </Template>
  );
};
